import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyTravelShootCreditBenefitsModal from './LandingPageLoyaltyTravelShootCreditBenefitsModal'

const image: App.Image = {
  id: 'r1z816jjifeqb5hwk50o',
  title: 'Pro photos on your trip',
}

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTravelShootCredit(props: Props) {
  const { tier, benefit, benefitLabel } = props

  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTravelShootCreditBenefitsModal
      image={image}
      tier={tier}
      benefitValue={benefit.value?.amount ?? 0}
      numberOfBenefitRemaining={benefit.remaining ?? 0}
    />)
  }, [showModal, tier, benefit.value, benefit.remaining])

  return <LandingPageLoyaltyBenefitTile
    heading="Pro photos on your trip"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Make the memories last. Use your Travelshoot voucher to book a professional{' '}
      photo session at your destination—perfect for couples, families, or solo travellers.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyTravelShootCredit
